import { css } from "@emotion/react";

export const CrudCollapseStyle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div
      className="relative"
      css={css`
        .ant-collapse-header,
        .ant-tabs-tab-active,
        .ant-collapse-content-box {
          background-color: #e9f6fe !important;
          border-color: #1890ff !important;
          border-style: solid !important;
          border-width: 1px !important;
        }
        .ant-collapse-content-box {
          background-color: white !important;
          border-top-width: 0 !important;
          border-bottom-right-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
        }
        .ant-collapse-content,
        .ant-collapse {
          border-width: 0px !important;
        }
      `}
    >
      {children}
    </div>
  );
};
